import { ACCOUNT_INFO_POLLING_INTERVAL } from 'config'
import { useEffect } from 'react'
import { useAppDispatch } from 'store'
import {
  useAccountInfo,
  useAccountTickets,
  useIsActivated,
} from 'store/account/hooks'
import { useInterval } from 'usehooks-ts'
import { getAccountBalanceAction } from './actions/getAccountBalanceActions'
import { getAccountInfoAction } from './actions/getAccountInfoActions'

export default function Updater() {
  usePollingAccountInfo()
  usePollingAccountBalance()
  return null
}

function usePollingAccountInfo() {
  const { address = '' } = useAccountInfo()
  const dispatch = useAppDispatch()
  const tickets = useAccountTickets()
  const accountAddress = tickets?.address ?? address
  const layerOneSignature = tickets?.signature
  const isActivated = useIsActivated()
  const polling = accountAddress && isActivated === false
  useInterval(
    () => {
      if (!accountAddress) return
      dispatch(
        getAccountInfoAction({
          address: accountAddress,
          signature: layerOneSignature,
          pubKey: tickets?.pubKey,
        }),
      )
    },
    polling ? ACCOUNT_INFO_POLLING_INTERVAL : null,
  )
}

function usePollingAccountBalance() {
  const { userId = 0, accountId = 0 } = useAccountInfo()
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!userId) return
    dispatch(getAccountBalanceAction(accountId))
  }, [userId])
  useInterval(
    () => {
      if (!userId) return
      dispatch(getAccountBalanceAction(accountId))
    },
    userId ? ACCOUNT_INFO_POLLING_INTERVAL : null,
  )
}
